var _path, _path2, _line, _line2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.3333L10 33.3333L10 6.66658L23.3333 6.66659L30 13.3333L30 33.3333Z",
    stroke: "#8E53E8",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.666 6.66663L21.666 15.8333L29.9993 15.8333",
    stroke: "#8E53E8",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 22.5333,
    x2: 25,
    y2: 22.5333,
    stroke: "#8E53E8",
    strokeWidth: 1.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 27.5333,
    x2: 25,
    y2: 27.5333,
    stroke: "#8E53E8",
    strokeWidth: 1.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.fe9f2023812a86f4f7e728926f82f093.svg";
export { ForwardRef as ReactComponent };